// grensesnitt/hero: the background video starts here rather than via `autoplay`,
// so reduced motion can keep it still, and the pause button reflects its state.
const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' )

document.querySelectorAll( '.hero' ).forEach( hero => {
  const video = hero.querySelector( '.hero__video' )
  const toggle = hero.querySelector( '.hero__video-toggle' )
  if ( !video || !toggle ) return

  const sync = () => toggle.setAttribute( 'aria-pressed', video.paused ? 'true' : 'false' )
  video.addEventListener( 'play', sync )
  video.addEventListener( 'pause', sync )

  toggle.addEventListener( 'click', () => {
    video.paused ? video.play() : video.pause()
  } )

  toggle.hidden = false
  sync()

  if ( !prefersReducedMotion.matches ) {
    video.play().catch( sync )
  }
} )
